const isNumber = (value: unknown): value is number => typeof value === 'number';

export default isNumber;
